module.exports = __webpack_public_path__ + "static/media/User Settings 2.352916df.svg";